export default __webpack_public_path__ + "static/media/2069.8f35bc70.png";